import { helper } from '@ember/component/helper';

export default helper(function includesType([types, component]) {
  if (!types) {
    return true;
  }
  if (!component) {
    return false;
  }
  let compType = component.type || (component.get && component.get('type'));
  return types.includes(compType);
});
